<div class="links gap-3">
  <a data-test="server-error-page_link-phone1" *ngIf="this.contacts?.phone1?.isShow" class="phone" href="{{ this.contacts.phone1?.href }}">{{
    this.contacts.phone1?.text
  }}</a>
  <a data-test="server-error-page_link-phone2" *ngIf="this.contacts?.phone2?.isShow" class="phone" href="{{ this.contacts.phone2?.href }}">{{
    this.contacts.phone2?.text
  }}</a>
  <a data-test="server-error-page_link-phone3" *ngIf="this.contacts?.phone3?.isShow" class="phone" href="{{ this.contacts.phone3?.href }}">{{
    this.contacts.phone3?.text
  }}</a>
  <a data-test="server-error-page_link-mail" *ngIf="this.contacts?.mail?.isShow" class="mail" href="{{ this.contacts.mail?.href }}">{{
    this.contacts.mail?.text
  }}</a>
  <a
    data-test="server-error-page_link-telegram"
    *ngIf="this.contacts?.telegram?.isShow"
    class="telegram"
    href="{{ this.contacts.telegram?.href }}"
    target="_blank"
    >{{ this.contacts.telegram?.text | translit  }}</a
  >
</div>
